let url = "";

url = process.env.REACT_APP_BASE_URL;

export const BACKEND_BASE_URL = url;
